import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  hidden: {
    display: 'none',
  },
}));

export default useStyles;
